/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const Newsletter = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domNewsSubmitBtn: $('.ctct-submit'),
	$domNewsSubmitIcon: $('.js-news-sub-icon'),
	$domNewsEmailInput: $('.ctct-email'),

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.clickSubmit();
		this.enterSubmit();

		setTimeout(() => {
			$('.ctct-form-element').attr('placeholder', 'Email Address');
		}, 3500);
	},

	clickSubmit: function() {
		Newsletter.$domNewsSubmitIcon.on('click', function() {
			Newsletter.$domNewsSubmitBtn.click();
		});
	},

	enterSubmit: function() {
		Newsletter.$domNewsEmailInput.keypress(function(e) {
			const key = e.which;
			if (key === 13) {
				Newsletter.$domNewsSubmitBtn.click();
				return false;
			}
		});
	}
};

export default Newsletter;
